const fundTh = { collections: 'เงินต้องนำส่ง', reserve: 'เงินสดย่อย', bond: 'เงินประกัน' }
const fundEn = { collections: 'Collections', reserve: 'Reserve', bond: 'Security deposit' }
const reviewTh = { none: 'ไม่มี', pending: 'รอตรวจ', approved: 'ยืนยันแล้ว', rejected: 'ไม่ยืนยัน' }
const reviewEn = { none: 'None', pending: 'To review', approved: 'Approved', rejected: 'Rejected' }
const categoryTh = {
  fuel: 'ค่าน้ำมัน',
  toll: 'ค่าทางด่วน / ที่จอด',
  supplies: 'วัสดุสิ้นเปลือง',
  repair: 'ค่าซ่อม',
  meal: 'ค่าอาหาร / รับรอง',
  postage: 'ค่าส่งเอกสาร',
  other: 'อื่น ๆ',
}
const categoryEn = {
  fuel: 'Fuel',
  toll: 'Tolls / parking',
  supplies: 'Supplies',
  repair: 'Repairs',
  meal: 'Meals',
  postage: 'Postage',
  other: 'Other',
}

export const th = {
  nav: {
    title: 'เงินสด',
    wallet: 'ถุงเงิน',
    overview: 'ภาพรวมเงินสด',
    transfers: 'การโอนหนี้',
    deposits: 'การนำฝากธนาคาร',
    reserves: 'รับ / เติม / คืนเงินสดย่อย',
    expenses: 'ค่าใช้จ่ายเงินสดย่อย',
    claims: 'เบิกค่าใช้จ่าย',
    bonds: 'เงินประกัน',
    safes: 'เซฟ',
    moves: 'โยกเงิน',
    entries: 'ประวัติเงินสด',
  },
  fund: fundTh,
  entry: {
    title: 'รายการเงินสด',
    plural: 'ประวัติเงินสด',
    fields: {
      at: 'เวลา',
      userId: 'ผู้ถือเงิน',
      safeId: 'เซฟ',
      fund: 'ประเภทเงิน',
      branchId: 'สาขา',
      source: 'ที่มา',
      sourceId: 'เอกสาร',
      sourceNumber: 'เลขที่เอกสาร',
      summary: 'รายการ',
      amount: 'เข้า / ออก',
      balance: 'คงเหลือ',
      byUserId: 'บันทึกโดย',
    },
    options: {
      fund: fundTh,
      source: {
        receipt: 'ใบเสร็จ',
        payment: 'ใบรับเงิน',
        transfer: 'โอนหนี้',
        deposit: 'นำฝาก',
        reserve: 'รับ / เติม / คืนเงินสดย่อย',
        expense: 'ค่าใช้จ่ายเงินสดย่อย',
        advance: 'เบิกล่วงหน้า',
        refund: 'ใบคืนเงิน',
        payslip: 'สลิปเงินเดือน',
        bond: 'รับ / หักเงินประกัน',
        move: 'โยกเงิน',
      },
    },
  },
  transfer: {
    title: 'ใบโอนหนี้',
    plural: 'ใบโอนหนี้',
    create: 'โอนหนี้',
    fields: {
      number: 'เลขที่',
      sentAt: 'โอนเมื่อ',
      fromUserId: 'ผู้โอน',
      toUserId: 'โอนให้',
      toSafeId: 'เข้าเซฟ',
      receivedCount: 'นับเข้าเซฟได้',
      receivedByUserId: 'ผู้รับโอน / ผู้นับ',
      fund: 'กระเป๋า',
      amount: 'ยอดที่โอน',
      counted: 'นับเงินสดได้ (ทั้งหมดที่ถืออยู่)',
      variance: 'ขาด / เกิน',
      varianceReason: 'เหตุผลที่เงินขาดหรือเกิน',
      varianceStatus: 'ตรวจเงินขาด / เกิน',
      varianceReviewedBy: 'ตรวจโดย',
      varianceReviewedAt: 'ตรวจเมื่อ',
      varianceReviewNote: 'หมายเหตุการตรวจ',
      status: 'สถานะ',
      receivedAt: 'รับเมื่อ',
      recordedByUserId: 'บันทึกโดย',
      onBehalf: 'บันทึกแทน',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
    },
    options: {
      fund: fundTh,
      status: { draft: 'ร่าง', sent: 'รอผู้รับยืนยัน', received: 'รับแล้ว', cancelled: 'ยกเลิก' },
      varianceStatus: { none: 'ไม่มี', pending: 'รอหัวหน้าตรวจ', approved: 'หัวหน้ายืนยันแล้ว', rejected: 'หัวหน้าไม่ยืนยัน' },
    },
    sections: { main: 'โอนหนี้', count: 'นับเงินสดก่อนโอน (ไม่บังคับ)', other: 'หมายเหตุ' },
    actions: {
      receive: 'รับโอนหนี้',
      approveVariance: 'ยืนยันเงินขาด / เกิน',
      rejectVariance: 'ไม่ยืนยัน',
    },
    print: { title: 'ใบโอนหนี้', from: 'ผู้โอน', to: 'ผู้รับโอน', custodian: 'ผู้ดูแลเซฟที่นับรับ', recordedBy: 'บันทึกโดย' },
    send: {
      title: 'โอนหนี้',
      titleSafe: 'นำเงินเข้าเซฟ',
      step: 'ขั้นที่ {{step}} จาก 3',
      who: 'โอนหนี้ให้ใคร',
      whoOrSafe: 'โอนหนี้ให้ใคร หรือนำเงินเข้าเซฟ',
      safes: 'เซฟ',
      safe: 'เซฟ',
      intoSafe: 'นำเข้า',
      howMuchSafe: 'นำเข้าเซฟเท่าไร',
      safeCounts: 'ผู้ดูแลเซฟนับเงินตอนรับ ไม่ต้องนับก่อนส่ง',
      sentenceSafe: 'นำ {{amount}} บาท เข้า{{name}}',
      safeNote: 'ยอดนี้ออกจากเงินต้องนำส่งของคุณทันที ผู้ดูแล{{name}}นับแล้วกดรับ ถ้ายอดที่นับไม่ตรง ส่วนต่างอยู่ที่คุณจนกว่าหัวหน้าตรวจ',
      confirmSafe: 'ยืนยันนำเข้าเซฟ',
      search: 'ค้นหาชื่อ',
      recent: 'โอนล่าสุด',
      sameBranch: 'คนในสาขาเดียวกัน',
      everyone: 'ทุกคน',
      results: 'ผลการค้นหา',
      noMatch: 'ไม่พบชื่อนี้',
      noMatchHint: 'ลองพิมพ์ชื่อเล่นหรือชื่อผู้ใช้',
      driver: 'คนขับรถ',
      to: 'โอนให้',
      change: 'เปลี่ยน',
      howMuch: 'โอนเท่าไร',
      amount: 'จำนวนเงิน',
      held: 'มีเงินต้องนำส่ง {{amount}} บาท',
      sendAll: 'ทั้งหมด {{amount}}',
      count: 'นับเงินสดก่อนโอน',
      countHint: 'ไม่บังคับ · นับเงินสดทั้งหมดที่ถืออยู่ แล้วระบบเทียบกับยอดในระบบ',
      counted: 'นับได้ทั้งหมด',
      expected: 'ยอดในระบบ {{amount}} บาท',
      matches: 'ตรงกับยอดในระบบ',
      note: 'หมายเหตุ',
      noteHint: 'ไม่บังคับ',
      next: 'ต่อไป',
      sentence: 'โอนหนี้ {{amount}} บาท ให้ {{name}}',
      overCount: 'มากกว่าเงินที่นับได้ ({{amount}} บาท)',
      sendNote: 'ยอดนี้ออกจากเงินต้องนำส่งของคุณทันที {{name}} กดรับโอนแล้วเป็นคนนำส่งบริษัทแทน ถ้าไม่รับ ยอดกลับมาที่คุณ',
      confirm: 'ยืนยันโอนหนี้',
      edit: 'แก้ไข',
      failed: 'โอนหนี้ไม่สำเร็จ',
      you: 'คุณ',
    },
    slip: {
      sent: 'โอนหนี้แล้ว',
      sentSafe: 'นำเงินเข้าเซฟแล้ว',
      receivedFrom: 'รับโอนหนี้จาก {{name}} แล้ว',
      waiting: 'รอ {{name}} รับโอน',
      waitingSafe: 'รอผู้ดูแล{{name}}นับรับ',
      receivedSafe: 'นับรับเข้า{{name}}แล้ว',
      stepCounted: 'นับรับเข้าเซฟ',
      receivedBy: '{{name}} รับโอนแล้ว',
      incoming: '{{name}} โอนหนี้ให้คุณ',
      takeOver: 'รับแล้วคุณเป็นคนนำส่งยอดนี้ให้บริษัทแทน ตรวจว่าเงินสดยอดนี้อยู่กับคุณก่อนกดรับ',
      confirmTitle: 'รับโอนหนี้',
      confirmBody: 'รับหนี้ {{amount}} บาท จาก {{name}} เข้าเงินต้องนำส่งของคุณ',
      cancelled: 'ยกเลิกแล้ว',
      stepSent: 'โอนหนี้',
      stepIntoSafe: 'นำเข้าเซฟ',
      stepReceived: 'รับโอน',
      notYet: 'รอยืนยัน',
      recordedBy: 'บันทึกแทนโดย {{name}}',
      done: 'เสร็จสิ้น',
      review: 'ตรวจเงินขาด / เกิน',
    },
  },
  deposit: {
    title: 'ใบนำฝาก',
    plural: 'ใบนำฝาก',
    create: 'นำฝากธนาคาร',
    fields: {
      number: 'เลขที่',
      depositedOn: 'วันที่ฝาก',
      userId: 'ผู้นำฝาก',
      safeId: 'ฝากจากเซฟ',
      amount: 'จำนวนเงิน',
      bankAccount: 'บัญชีบริษัทที่ฝาก',
      reference: 'เลขที่รายการ',
      slipId: 'สลิปนำฝาก',
      status: 'สถานะ',
      verifiedAt: 'ตรวจเมื่อ',
      verifiedBy: 'ตรวจโดย',
      recordedByUserId: 'บันทึกโดย',
      onBehalf: 'บันทึกแทน',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
    },
    options: { status: { draft: 'ร่าง', deposited: 'ฝากแล้ว รอตรวจ', verified: 'ตรวจกับ statement แล้ว', cancelled: 'ยกเลิก' } },
    sections: { main: 'นำเงินต้องนำส่งฝากเข้าบัญชีบริษัท', other: 'หมายเหตุ' },
    actions: { verify: 'ตรวจกับ statement แล้ว' },
  },
  reserve: {
    title: 'ใบรับ / เติม / คืนเงินสดย่อย',
    plural: 'รับ / เติม / คืนเงินสดย่อย',
    create: 'ให้ / เติมเงินสดย่อย',
    createReturn: 'คืนเงินสดย่อย',
    fields: {
      number: 'เลขที่',
      sentAt: 'ส่งเมื่อ',
      kind: 'ประเภท',
      purpose: 'เพื่อ',
      userId: 'ผู้ถือเงินสดย่อย',
      amount: 'จำนวนเงิน',
      status: 'สถานะ',
      receivedAt: 'รับเมื่อ',
      sentByUserId: 'ผู้ส่ง',
      recordedByUserId: 'บันทึกโดย',
      onBehalf: 'บันทึกแทน',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
    },
    options: {
      kind: { issue: 'ให้ / เติม', return: 'คืน' },
      purpose: { setup: 'ตั้งหรือเพิ่มวงเงิน', topUp: 'เติมคืนตามที่ใช้ไป' },
      status: { draft: 'ร่าง', sent: 'ระหว่างส่ง', received: 'รับแล้ว', cancelled: 'ยกเลิก' },
    },
    sections: { main: 'เงินสดย่อย', other: 'หมายเหตุ' },
    actions: { receive: 'ยืนยันรับเงินสดย่อย', receiveReturn: 'ยืนยันรับเงินคืน' },
    confirm: {
      title: 'ยืนยันรับเงินสดย่อย',
      body: 'ได้รับเงิน {{amount}} บาท จาก {{name}} ครบแล้ว',
      countFirst: 'นับเงินให้ครบก่อนกดยืนยัน',
    },
    topUpHint: 'ใช้ไป {{amount}} บาท จากวงเงิน {{limit}} บาท',
    topUpSuggest: 'เติม {{amount}} บาท',
  },
  bond: {
    title: 'ใบรับ / หัก / คืนเงินประกัน',
    plural: 'เงินประกัน',
    create: 'รับ / หัก / คืนเงินประกัน',
    fields: {
      number: 'เลขที่',
      kind: 'รายการ',
      userId: 'เงินประกันของ',
      amount: 'จำนวนเงิน',
      reason: 'เงินขาดหรือความเสียหายอะไร',
      submittedAt: 'บันทึกเมื่อ',
      recordedByUserId: 'บันทึกโดย',
      branchId: 'สาขา',
      method: 'คืนด้วย',
      reference: 'เลขอ้างอิงการโอน',
      slipId: 'รูปสลิปโอน',
      notes: 'หมายเหตุ',
    },
    options: { kind: { payIn: 'รับเงินประกัน', shortage: 'หักชดเชยเงินขาด', damage: 'หักชดเชยความเสียหาย', refund: 'คืนเงินประกัน' } },
    sections: { main: 'เงินประกัน', other: 'หมายเหตุ' },
    held: 'มีเงินประกัน {{bond}} บาท · เงินต้องนำส่ง {{collections}} บาท',
    closed: 'ปิดบัญชีแล้ว',
    hint: {
      payIn: 'คุณรับเงินสดจากเจ้าตัว เงินเข้าเงินประกันของเขาและเงินต้องนำส่งของคุณ',
      shortage: 'หักจากเงินประกันไปเคลียร์เงินต้องนำส่งที่เจ้าตัวไม่มีเงินส่ง ไม่เกินเงินต้องนำส่งที่ค้างอยู่',
      damage: 'หักจากเงินประกันชดเชยความเสียหายที่เจ้าตัวทำ',
      refund: 'คืนเงินประกันให้เจ้าตัว: เงินสดออกจากเงินต้องนำส่งของคุณ หรือโอนแล้วใส่เลขอ้างอิงหรือแนบสลิป คนที่พ้นสภาพต้องได้คืนภายใน 7 วันหลังวันทำงานวันสุดท้าย',
    },
  },
  expense: {
    title: 'ค่าใช้จ่ายเงินสดย่อย',
    plural: 'ค่าใช้จ่ายเงินสดย่อย',
    create: 'จ่ายเงินสดย่อย',
    fields: {
      number: 'เลขที่',
      spentOn: 'วันที่จ่าย',
      category: 'หมวด',
      amount: 'จำนวนเงิน',
      payee: 'จ่ายให้ (ร้าน / ผู้รับเงิน)',
      vehicleId: 'รถ',
      description: 'รายละเอียด',
      receiptFileId: 'รูปใบเสร็จ',
      useCollections: 'เงินสดย่อยไม่พอ ใช้เงินต้องนำส่งจ่ายส่วนที่เหลือ',
      collectionsReason: 'เหตุผลที่ต้องใช้เงินต้องนำส่ง',
      fromReserve: 'จ่ายจากเงินสดย่อย',
      fromCollections: 'จ่ายจากเงินต้องนำส่ง',
      reviewStatus: 'บัญชีตรวจ',
      reviewedBy: 'ตรวจโดย',
      reviewedAt: 'ตรวจเมื่อ',
      reviewNote: 'หมายเหตุการตรวจ',
      userId: 'ผู้จ่าย',
      recordedByUserId: 'บันทึกโดย',
      onBehalf: 'บันทึกแทน',
      branchId: 'สาขา',
    },
    options: { category: categoryTh, reviewStatus: { ...reviewTh, pending: 'รอบัญชีตรวจ' } },
    sections: { main: 'จ่ายเงินสดย่อย', collections: 'ถ้าเงินสดย่อยไม่พอ' },
    actions: { approve: 'ยืนยัน', reject: 'ไม่ยืนยัน' },
    covered: 'เงินสดย่อยพอจ่าย',
    split: 'จากเงินสดย่อย {{reserve}} บาท · จากเงินต้องนำส่ง {{collections}} บาท',
    short: 'เงินสดย่อยไม่พอ ขาด {{amount}} บาท',
    flow: {
      what: 'จ่ายค่าอะไร',
      howMuch: 'จ่ายเท่าไร',
      change: 'เปลี่ยน',
      reserveHeld: 'มีเงินสดย่อย {{amount}} บาท',
      useCollections: 'ใช้เงินต้องนำส่งจ่ายส่วนที่เหลือ',
      collectionsHeld: 'มีเงินต้องนำส่ง {{amount}} บาท',
      collectionsShort: 'เงินต้องนำส่งก็ไม่พอ (มี {{amount}} บาท)',
      splitReview: 'ส่วนที่ใช้เงินต้องนำส่งรอฝ่ายบัญชีตรวจ',
      receipt: 'รูปใบเสร็จ',
      takePhoto: 'ถ่ายรูปใบเสร็จ',
      photoHint: 'หรือเลือกรูป / PDF จากเครื่อง',
      retake: 'เปลี่ยนรูป',
      details: 'รายละเอียด',
      payeeHint: 'เช่น ชื่อปั๊ม ชื่อร้าน',
      descriptionHint: 'ซื้ออะไร ใช้กับงานไหน',
      next: 'ต่อไป',
      sentence: 'จ่าย {{amount}} บาท ให้ {{payee}}',
      paidNote: 'เงินออกจากเงินสดย่อยของคุณทันที',
      paidNoteSplit: 'ส่วนที่ใช้เงินต้องนำส่ง {{collections}} บาท รอฝ่ายบัญชีตรวจ',
      confirm: 'ยืนยันจ่าย',
      edit: 'แก้ไข',
      failed: 'จ่ายเงินสดย่อยไม่สำเร็จ',
    },
    slip: {
      paid: 'จ่ายแล้ว',
      payee: 'จ่ายให้',
      stepPaid: 'จ่ายเงิน',
      stepReview: 'ฝ่ายบัญชีตรวจ',
      notYet: 'รอตรวจ',
      reviewHint: 'ยืนยัน: เป็นค่าใช้จ่ายของบริษัท · ไม่ยืนยัน: ผู้จ่ายต้องใส่คืนในเงินต้องนำส่ง',
      fromReserve: 'จากเงินสดย่อย {{amount}} บาท',
      pending: 'รอฝ่ายบัญชีตรวจ',
      pendingText: 'ส่วนที่ใช้เงินต้องนำส่ง {{amount}} บาท',
      approved: 'ฝ่ายบัญชียืนยันแล้ว',
      rejected: 'ฝ่ายบัญชีไม่ยืนยัน',
      rejectedText: 'ต้องใส่คืน {{amount}} บาท ในเงินต้องนำส่ง',
      cancelled: 'ยกเลิกแล้ว',
      review: 'ตรวจการใช้เงินต้องนำส่ง',
      editDetails: 'แก้ไขรายละเอียด',
      saved: 'บันทึกแล้ว',
      viewReceipt: 'ดูรูปใบเสร็จ',
      done: 'เสร็จสิ้น',
    },
  },
  claim: {
    title: 'ใบเบิกค่าใช้จ่าย',
    plural: 'เบิกค่าใช้จ่าย',
    create: 'เบิกค่าใช้จ่าย',
    fields: {
      number: 'เลขที่',
      spentOn: 'วันที่จ่าย',
      category: 'หมวด',
      amount: 'จำนวนเงิน',
      payee: 'จ่ายให้ (ร้าน / ผู้รับเงิน)',
      vehicleId: 'รถ',
      description: 'รายละเอียด',
      receiptFileId: 'รูปใบเสร็จ',
      payBank: 'ธนาคาร',
      payBankAccount: 'เลขบัญชี',
      payBankAccountName: 'ชื่อบัญชี',
      status: 'สถานะ',
      userId: 'ผู้เบิก',
      branchId: 'สาขา',
      approvedByUserId: 'อนุมัติโดย',
      approvedAt: 'อนุมัติเมื่อ',
      rejectNote: 'เหตุผลที่ไม่อนุมัติ',
      paidByUserId: 'โอนคืนโดย',
      paidAt: 'บันทึกการโอนเมื่อ',
      paidOn: 'วันที่โอนคืน',
      paidReference: 'เลขอ้างอิงการโอน',
      slipId: 'สลิปการโอน',
    },
    options: {
      category: categoryTh,
      status: { draft: 'ร่าง', requested: 'รออนุมัติ', approved: 'รอโอนคืน', paid: 'โอนคืนแล้ว', rejected: 'ไม่อนุมัติ', cancelled: 'ยกเลิก' },
    },
    sections: { main: 'เบิกค่าใช้จ่าย', payTo: 'โอนคืนเข้าบัญชี' },
    actions: { approve: 'อนุมัติ', reject: 'ไม่อนุมัติ', pay: 'บันทึกโอนคืน' },
    flow: {
      what: 'จ่ายค่าอะไรไป',
      howMuch: 'จ่ายไปเท่าไร',
      sentence: 'เบิก {{amount}} บาท ที่จ่ายให้ {{payee}}',
      payTo: 'โอนคืนเข้าบัญชี',
      payrollAccount: 'บัญชีเงินเดือนของคุณ',
      noPayrollAccount: 'ยังไม่มีบัญชีเงินเดือน ใส่บัญชีที่จะรับเงินคืน',
      note: 'หัวหน้างานของคุณหรือฝ่ายบัญชีอนุมัติ แล้วฝ่ายบัญชีโอนคืนให้',
      confirm: 'ส่งเบิก',
      failed: 'ส่งเบิกไม่สำเร็จ',
    },
    slip: {
      stepRequested: 'ส่งเบิก',
      stepApproved: 'อนุมัติ',
      stepPaid: 'โอนคืน',
      notYet: 'ยังไม่ถึง',
      requested: 'รออนุมัติ',
      requestedText: 'หัวหน้างานหรือฝ่ายบัญชีอนุมัติ แล้วฝ่ายบัญชีโอนคืน',
      approved: 'อนุมัติแล้ว รอโอนคืน',
      approvedText: 'ฝ่ายบัญชีจะโอนคืนเข้าบัญชีของผู้เบิก',
      paid: 'โอนคืนแล้ว',
      paidText: 'โอนคืนเมื่อ {{date}}',
      rejected: 'ไม่อนุมัติ',
      cancelled: 'ยกเลิกแล้ว',
      claimant: 'ผู้เบิก',
      payTo: 'โอนคืนเข้าบัญชี',
      decide: 'อนุมัติการเบิก',
      decideHint: 'อนุมัติ: ฝ่ายบัญชีโอนคืนให้ · ไม่อนุมัติ: ใส่เหตุผล ผู้เบิกเห็น',
      payHint: 'โอน {{amount}} บาท เข้าบัญชีนี้ แล้วบันทึกพร้อมสลิป',
      copy: 'คัดลอกเลขบัญชี',
      copied: 'คัดลอกเลขบัญชีแล้ว',
      viewSlip: 'ดูสลิป',
      approvedDone: 'อนุมัติ {{number}} แล้ว',
      rejectedDone: 'ไม่อนุมัติ {{number}} แล้ว',
      paidDone: 'บันทึกโอนคืน {{number}} แล้ว',
      done: 'เสร็จสิ้น',
    },
  },
  safe: {
    title: 'เซฟ',
    plural: 'เซฟ',
    create: 'เพิ่มเซฟ',
    fields: {
      name: 'ชื่อเซฟ',
      branchId: 'อยู่ที่สาขา',
      custodianUserIds: 'ผู้ดูแลเซฟ',
      status: 'สถานะ',
      notes: 'หมายเหตุ',
    },
    options: { status: { active: 'ใช้งาน', inactive: 'เลิกใช้' } },
    mine: 'เซฟที่คุณดูแล',
    all: 'เงินในเซฟ',
    none: 'ยังไม่มีเซฟ',
    noneHint: 'ฝ่ายบัญชีเพิ่มเซฟที่มีจริง และตั้งผู้ดูแลแต่ละเซฟ',
    waiting: 'รอนับ',
    waitingCount: 'รอนับ {{count}} รายการ',
    incoming: '{{name}} นำเงินเข้าเซฟ',
    count: 'นับรับ',
    countTitle: 'นับรับเข้า{{safe}}',
    countBody: '{{name}} นำเงิน {{amount}} บาท เข้าเซฟ นับให้ครบแล้วใส่ยอดที่นับได้',
    counted: 'นับได้',
    matches: 'ตรงกับที่ส่ง',
    note: 'เหตุผลที่ยอดไม่ตรง',
    varianceNote: 'เซฟรับตามยอดที่นับได้ ส่วนต่างอยู่ที่ผู้ส่งจนกว่าหัวหน้าตรวจ',
    confirm: 'ยืนยันรับเข้าเซฟ',
    done: 'รับ {{amount}} บาท เข้า{{safe}}แล้ว',
    deposit: 'นำฝากจากเซฟ',
    source: 'นำฝากเงินจาก',
    own: 'เงินในมือคุณ',
  },
  move: {
    title: 'ใบโยกเงิน',
    plural: 'ใบโยกเงิน',
    create: 'โยกเงิน',
    fields: {
      number: 'เลขที่',
      movedAt: 'โยกเมื่อ',
      fromUserId: 'จากคน',
      fromSafeId: 'จากเซฟ',
      fromFund: 'จากกระเป๋า',
      toUserId: 'ไปที่คน',
      toSafeId: 'ไปที่เซฟ',
      toFund: 'เข้ากระเป๋า',
      amount: 'จำนวนเงิน',
      reason: 'เหตุผล',
      recordedByUserId: 'โยกโดย',
      notes: 'หมายเหตุ',
    },
    options: { fromFund: fundTh, toFund: fundTh },
    sections: { from: 'โยกจาก', to: 'โยกไปที่', main: 'จำนวนเงินและเหตุผล' },
    person: 'คน',
    safe: 'เซฟ',
    hint: 'มีผลทันทีที่บันทึก ไม่ต้องมีใครยืนยัน โยกเงินเข้าหรือออกจากมือตัวเองไม่ได้',
  },
  wallet: {
    title: 'ถุงเงิน',
    total: 'เงินสดที่ควรมีในมือ',
    collections: 'เงินต้องนำส่ง',
    collectionsHint: 'ยอดที่ต้องนำส่งบริษัท ต้องเป็น 0 ทุกสิ้นวัน',
    collectionsOver: 'นำส่งเกินไป {{amount}} บาท',
    reserve: 'เงินสดย่อย',
    reserveHint: 'บริษัทให้ถือไว้ทอนเงินและจ่ายค่าใช้จ่าย',
    reserveOf: '{{held}} จากวงเงิน {{limit}} บาท',
    reserveOver: 'ใช้เกินไป {{amount}} บาท (วงเงิน {{limit}} บาท)',
    bond: 'เงินประกัน',
    bondHint: 'เงินของคุณที่บริษัทเก็บไว้ ได้คืนพร้อมเงินเดือนงวดสุดท้าย',
    bondOf: '{{held}} จากเป้า {{target}} บาท',
    bondHeld: '{{held}} บาท',
    bondOver: 'หักเกินไป {{amount}} บาท',
    clearing: 'ถ้าเคลียร์วันนี้',
    clearingHint: 'เงินต้องนำส่งกับเงินสดย่อยที่ต้องคืน หักเงินประกันที่บริษัทคืนให้',
    clearingPay: 'คุณต้องส่งบริษัท {{amount}} บาท',
    clearingRefund: 'บริษัทต้องคืนคุณ {{amount}} บาท',
    clearingNone: 'ไม่ต้องส่งและไม่มีเงินคืน',
    inTransit: 'รออีกฝ่ายยืนยัน {{amount}} บาท',
    incoming: 'รอคุณยืนยัน',
    incomingFrom: '{{name}} โอนมา {{amount}} บาท',
    incomingReserve: '{{name}} ให้เงินสดย่อย {{amount}} บาท',
    incomingReserveTo: '{{name}} ให้เงินสดย่อยคุณ',
    outgoing: 'รออีกฝ่ายยืนยัน',
    waiting: 'รอยืนยัน',
    received: 'รับเงิน {{amount}} บาท จาก {{name}} แล้ว',
    takenOver: 'รับโอนหนี้ {{amount}} บาท จาก {{name}} แล้ว',
    recent: 'รายการเข้าออกล่าสุด',
    seeAll: 'ดูทั้งหมด',
    none: 'ยังไม่มีรายการเงินสด',
    expected: 'ยอดในระบบ',
    short: 'เงินขาด {{amount}} บาท',
    over: 'เงินเกิน {{amount}} บาท',
    notEnough: 'เงินต้องนำส่งไม่พอ (มี {{amount}} บาท)',
    reviewNote: 'หมายเหตุ (ต้องใส่เมื่อไม่ยืนยัน)',
    reviewed: 'บันทึกผลตรวจแล้ว',
    printSlip: 'พิมพ์ใบโอนหนี้',
    sendAll: 'โอนเงินต้องนำส่งทั้งหมด {{amount}} บาท',
  },
  overview: {
    title: 'ภาพรวมเงินสด',
    person: 'ผู้ถือเงิน',
    collections: 'เงินต้องนำส่ง',
    reserve: 'เงินสดย่อย',
    bond: 'เงินประกัน',
    bondTarget: 'เป้า',
    bondDue: 'คืนภายใน {{date}}',
    bondOverdue: 'เลยกำหนดคืน {{date}}',
    bondRefund: 'คืน',
    bondsDue: 'เงินประกันรอคืน',
    reserveLimit: 'วงเงิน',
    toTopUp: 'ควรเติม',
    inTransit: 'รออีกฝ่ายยืนยัน',
    lastHandover: 'เคลียร์ยอดล่าสุด',
    days: '{{count}} วันก่อน',
    today: 'วันนี้',
    never: 'ยังไม่เคยเคลียร์',
    total: 'รวม',
    depositsPending: 'นำฝากรอตรวจ',
    variancesPending: 'เงินขาด / เกินรอตรวจ',
    expensesPending: 'ใช้เงินต้องนำส่งจ่าย รอบัญชีตรวจ',
  },
}

export const en = {
  nav: {
    title: 'Cash',
    wallet: 'Money bag',
    overview: 'Cash overview',
    transfers: 'Debt transfers',
    deposits: 'Bank deposits',
    reserves: 'Petty cash issued / returned',
    expenses: 'Petty cash expenses',
    claims: 'Expense claims',
    bonds: 'Security deposits',
    safes: 'Safes',
    moves: 'Cash moves',
    entries: 'Cash history',
  },
  fund: fundEn,
  entry: {
    title: 'Cash entry',
    plural: 'Cash history',
    fields: {
      at: 'Time',
      userId: 'Held by',
      safeId: 'Safe',
      fund: 'Kind of money',
      branchId: 'Branch',
      source: 'Source',
      sourceId: 'Document',
      sourceNumber: 'Document no.',
      summary: 'Entry',
      amount: 'In / out',
      balance: 'Balance',
      byUserId: 'Recorded by',
    },
    options: {
      fund: fundEn,
      source: {
        receipt: 'Receipt',
        payment: 'Payment',
        transfer: 'Debt transfer',
        deposit: 'Deposit',
        reserve: 'Petty cash issued / returned',
        expense: 'Petty cash expense',
        advance: 'Salary advance',
        refund: 'Refund',
        payslip: 'Payslip',
        bond: 'Security deposit paid in / used',
        move: 'Cash move',
      },
    },
  },
  transfer: {
    title: 'Debt transfer',
    plural: 'Debt transfers',
    create: 'Transfer debt',
    fields: {
      number: 'No.',
      sentAt: 'Transferred at',
      fromUserId: 'From',
      toUserId: 'To',
      toSafeId: 'Into safe',
      receivedCount: 'Counted into the safe',
      receivedByUserId: 'Taken over / counted by',
      fund: 'Fund',
      amount: 'Amount transferred',
      counted: 'Cash counted (everything held)',
      variance: 'Short / over',
      varianceReason: 'Why it is short or over',
      varianceStatus: 'Short / over review',
      varianceReviewedBy: 'Reviewed by',
      varianceReviewedAt: 'Reviewed at',
      varianceReviewNote: 'Review note',
      status: 'Status',
      receivedAt: 'Received at',
      recordedByUserId: 'Recorded by',
      onBehalf: 'Recorded for someone',
      branchId: 'Branch',
      notes: 'Notes',
    },
    options: {
      fund: fundEn,
      status: { draft: 'Draft', sent: 'Waiting to be accepted', received: 'Accepted', cancelled: 'Cancelled' },
      varianceStatus: { none: 'None', pending: 'Waiting for a lead', approved: 'Approved', rejected: 'Rejected' },
    },
    sections: { main: 'Transfer debt', count: 'Count your cash first (optional)', other: 'Notes' },
    actions: {
      receive: 'Take over the debt',
      approveVariance: 'Approve short / over',
      rejectVariance: 'Reject',
    },
    print: {
      title: 'Debt transfer',
      from: 'Transferred by',
      to: 'Taken over by',
      custodian: 'Counted in by (custodian)',
      recordedBy: 'Recorded by',
    },
    send: {
      title: 'Transfer debt',
      titleSafe: 'Put cash into a safe',
      step: 'Step {{step}} of 3',
      who: 'Who takes over your debt?',
      whoOrSafe: 'Who takes over your debt, or which safe?',
      safes: 'Safes',
      safe: 'Safe',
      intoSafe: 'Into',
      howMuchSafe: 'How much into the safe?',
      safeCounts: 'The safe’s custodian counts it in; no count needed now',
      sentenceSafe: 'Put {{amount}} baht into {{name}}',
      safeNote:
        'It leaves your collections now. A custodian of {{name}} counts it and confirms; a difference stays with you until a lead reviews it',
      confirmSafe: 'Put into the safe',
      search: 'Search by name',
      recent: 'Recent',
      sameBranch: 'Your branch',
      everyone: 'Everyone',
      results: 'Results',
      noMatch: 'No one by that name',
      noMatchHint: 'Try a nickname or username',
      driver: 'Driver',
      to: 'To',
      change: 'Change',
      howMuch: 'How much do you transfer?',
      amount: 'Amount',
      held: '{{amount}} baht of collections in hand',
      sendAll: 'All {{amount}}',
      count: 'Count your cash first',
      countHint: 'Optional · count all the cash you hold; it is compared with your balance',
      counted: 'Counted in all',
      expected: 'Balance {{amount}} baht',
      matches: 'Matches the balance',
      note: 'Note',
      noteHint: 'Optional',
      next: 'Next',
      sentence: 'Transfer {{amount}} baht of debt to {{name}}',
      overCount: 'More than you counted ({{amount}} baht)',
      sendNote:
        'It leaves your collections now. Once {{name}} accepts, they hand it in to the company for you; if not, it comes back to you',
      confirm: 'Transfer debt',
      edit: 'Edit',
      failed: 'The debt was not transferred',
      you: 'You',
    },
    slip: {
      sent: 'Debt transferred',
      sentSafe: 'Put into the safe',
      receivedFrom: 'Took over the debt from {{name}}',
      waiting: 'Waiting for {{name}} to take it over',
      waitingSafe: 'Waiting for a custodian of {{name}} to count it',
      receivedSafe: 'Counted into {{name}}',
      stepCounted: 'Counted into the safe',
      receivedBy: '{{name}} took it over',
      incoming: '{{name}} transferred their debt to you',
      takeOver: 'Once you accept, you hand this in to the company in their place: check the cash for it is with you first',
      confirmTitle: 'Take over the debt',
      confirmBody: '{{amount}} baht of debt from {{name}} joins your collections',
      cancelled: 'Cancelled',
      stepSent: 'Transferred',
      stepIntoSafe: 'Put into the safe',
      stepReceived: 'Taken over',
      notYet: 'Not yet',
      recordedBy: 'Recorded by {{name}}',
      done: 'Done',
      review: 'Short / over review',
    },
  },
  deposit: {
    title: 'Bank deposit',
    plural: 'Bank deposits',
    create: 'Deposit at the bank',
    fields: {
      number: 'No.',
      depositedOn: 'Deposited on',
      userId: 'Deposited by',
      safeId: 'From safe',
      amount: 'Amount',
      bankAccount: 'Company account',
      reference: 'Transaction ref.',
      slipId: 'Deposit slip',
      status: 'Status',
      verifiedAt: 'Verified at',
      verifiedBy: 'Verified by',
      recordedByUserId: 'Recorded by',
      onBehalf: 'Recorded for someone',
      branchId: 'Branch',
      notes: 'Notes',
    },
    options: { status: { draft: 'Draft', deposited: 'Deposited, to verify', verified: 'On the statement', cancelled: 'Cancelled' } },
    sections: { main: 'Deposit collections into the company account', other: 'Notes' },
    actions: { verify: 'Mark as on the statement' },
  },
  reserve: {
    title: 'Petty cash issue / return',
    plural: 'Petty cash issued / returned',
    create: 'Issue / top up petty cash',
    createReturn: 'Return petty cash',
    fields: {
      number: 'No.',
      sentAt: 'Sent at',
      kind: 'Kind',
      purpose: 'For',
      userId: 'Petty cash holder',
      amount: 'Amount',
      status: 'Status',
      receivedAt: 'Received at',
      sentByUserId: 'Sent by',
      recordedByUserId: 'Recorded by',
      onBehalf: 'Recorded for someone',
      branchId: 'Branch',
      notes: 'Notes',
    },
    options: {
      kind: { issue: 'Issue / top up', return: 'Return' },
      purpose: { setup: 'Set up or raise', topUp: 'Replace what was spent' },
      status: { draft: 'Draft', sent: 'In transit', received: 'Received', cancelled: 'Cancelled' },
    },
    sections: { main: 'Petty cash', other: 'Notes' },
    actions: {
      receive: 'Confirm petty cash received',
      receiveReturn: 'Confirm return received',
    },
    confirm: {
      title: 'Confirm petty cash received',
      body: 'You received {{amount}} baht from {{name}}, in full',
      countFirst: 'Count it all before you confirm',
    },
    topUpHint: '{{amount}} THB spent of {{limit}} THB',
    topUpSuggest: 'Top up {{amount}} THB',
  },
  bond: {
    title: 'Security deposit slip',
    plural: 'Security deposits',
    create: 'Take in / use / pay back a deposit',
    fields: {
      number: 'No.',
      kind: 'What',
      userId: 'Deposit of',
      amount: 'Amount',
      reason: 'What was short or damaged',
      submittedAt: 'Recorded at',
      recordedByUserId: 'Recorded by',
      branchId: 'Branch',
      method: 'Paid back by',
      reference: 'Transfer reference',
      slipId: 'Transfer slip',
      notes: 'Notes',
    },
    options: { kind: { payIn: 'Paid in', shortage: 'Covers a shortage', damage: 'Covers damage', refund: 'Paid back' } },
    sections: { main: 'Security deposit', other: 'Notes' },
    held: 'Deposit {{bond}} THB · collections {{collections}} THB',
    closed: 'Account closed',
    hint: {
      payIn: 'You take cash from them: it goes into their deposit and your collections',
      shortage: 'Their deposit clears collections they cannot hand in, up to what they owe',
      damage: 'Their deposit pays for damage they caused',
      refund:
        'Pay their deposit back: cash out of your collections, or a transfer with its reference or slip. Someone who has left gets it back within 7 days of their last day',
    },
  },
  expense: {
    title: 'Petty cash expense',
    plural: 'Petty cash expenses',
    create: 'Pay petty cash',
    fields: {
      number: 'No.',
      spentOn: 'Paid on',
      category: 'Category',
      amount: 'Amount',
      payee: 'Paid to',
      vehicleId: 'Vehicle',
      description: 'Details',
      receiptFileId: 'Receipt photo',
      useCollections: 'The petty cash is short: pay the rest from collections',
      collectionsReason: 'Why collections had to be used',
      fromReserve: 'From petty cash',
      fromCollections: 'From collections',
      reviewStatus: 'Accounting review',
      reviewedBy: 'Reviewed by',
      reviewedAt: 'Reviewed at',
      reviewNote: 'Review note',
      userId: 'Paid by',
      recordedByUserId: 'Recorded by',
      onBehalf: 'Recorded for someone',
      branchId: 'Branch',
    },
    options: { category: categoryEn, reviewStatus: { ...reviewEn, pending: 'Waiting for accounting' } },
    sections: { main: 'Pay petty cash', collections: 'If the petty cash is short' },
    actions: { approve: 'Approve', reject: 'Reject' },
    covered: 'The petty cash covers it',
    split: '{{reserve}} THB from petty cash · {{collections}} THB from collections',
    short: 'The petty cash is {{amount}} THB short',
    flow: {
      what: 'What did you pay for?',
      howMuch: 'How much?',
      change: 'Change',
      reserveHeld: '{{amount}} baht of petty cash in hand',
      useCollections: 'Pay the rest from collections',
      collectionsHeld: '{{amount}} baht of collections in hand',
      collectionsShort: 'Collections are short too ({{amount}} baht held)',
      splitReview: 'The part from collections waits for accounting',
      receipt: 'Receipt photo',
      takePhoto: 'Take a photo of the receipt',
      photoHint: 'or pick a photo / PDF',
      retake: 'Change photo',
      details: 'Details',
      payeeHint: 'e.g. the station, the shop',
      descriptionHint: 'What it was, for which job',
      next: 'Next',
      sentence: 'Pay {{amount}} baht to {{payee}}',
      paidNote: 'The cash leaves your petty cash now',
      paidNoteSplit: 'The {{collections}} baht from collections waits for accounting',
      confirm: 'Pay',
      edit: 'Edit',
      failed: 'The payment was not saved',
    },
    slip: {
      paid: 'Paid',
      payee: 'Paid to',
      stepPaid: 'Paid',
      stepReview: 'Accounting review',
      notYet: 'Not yet',
      reviewHint: 'Approve: a company expense · Reject: the payer puts it back into collections',
      fromReserve: '{{amount}} baht from petty cash',
      pending: 'Waiting for accounting',
      pendingText: '{{amount}} baht from collections',
      approved: 'Approved by accounting',
      rejected: 'Rejected by accounting',
      rejectedText: '{{amount}} baht to put back into collections',
      cancelled: 'Cancelled',
      review: 'Review the use of collections',
      editDetails: 'Edit details',
      saved: 'Saved',
      viewReceipt: 'View receipt',
      done: 'Done',
    },
  },
  claim: {
    title: 'Expense claim',
    plural: 'Expense claims',
    create: 'Claim an expense',
    fields: {
      number: 'No.',
      spentOn: 'Paid on',
      category: 'Category',
      amount: 'Amount',
      payee: 'Paid to',
      vehicleId: 'Vehicle',
      description: 'Details',
      receiptFileId: 'Receipt photo',
      payBank: 'Bank',
      payBankAccount: 'Account no.',
      payBankAccountName: 'Account name',
      status: 'Status',
      userId: 'Claimed by',
      branchId: 'Branch',
      approvedByUserId: 'Approved by',
      approvedAt: 'Approved at',
      rejectNote: 'Why it was rejected',
      paidByUserId: 'Paid back by',
      paidAt: 'Transfer recorded at',
      paidOn: 'Paid back on',
      paidReference: 'Transfer reference',
      slipId: 'Transfer slip',
    },
    options: {
      category: categoryEn,
      status: {
        draft: 'Draft',
        requested: 'To approve',
        approved: 'To pay back',
        paid: 'Paid back',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
    },
    sections: { main: 'Claim an expense', payTo: 'Pay back into' },
    actions: { approve: 'Approve', reject: 'Reject', pay: 'Record the transfer' },
    flow: {
      what: 'What did you pay for?',
      howMuch: 'How much did you pay?',
      sentence: 'Claim {{amount}} baht paid to {{payee}}',
      payTo: 'Pay back into',
      payrollAccount: 'Your payroll account',
      noPayrollAccount: 'No payroll account yet: give the account to pay back into',
      note: 'Your manager or accounting approves it, then accounting transfers it back',
      confirm: 'Send the claim',
      failed: 'The claim was not sent',
    },
    slip: {
      stepRequested: 'Claimed',
      stepApproved: 'Approved',
      stepPaid: 'Paid back',
      notYet: 'Not yet',
      requested: 'Waiting for approval',
      requestedText: 'Their manager or accounting approves it, then accounting transfers it back',
      approved: 'Approved, to pay back',
      approvedText: 'Accounting transfers it back into the claimant’s account',
      paid: 'Paid back',
      paidText: 'Transferred on {{date}}',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      claimant: 'Claimed by',
      payTo: 'Pay back into',
      decide: 'Approve the claim',
      decideHint: 'Approve: accounting transfers it back · Reject: give the reason, the claimant sees it',
      payHint: 'Transfer {{amount}} baht into this account, then record it with the slip',
      copy: 'Copy the account number',
      copied: 'Account number copied',
      viewSlip: 'View slip',
      approvedDone: '{{number}} approved',
      rejectedDone: '{{number}} rejected',
      paidDone: 'Transfer of {{number}} recorded',
      done: 'Done',
    },
  },
  safe: {
    title: 'Safe',
    plural: 'Safes',
    create: 'Add a safe',
    fields: {
      name: 'Name',
      branchId: 'At branch',
      custodianUserIds: 'Custodians',
      status: 'Status',
      notes: 'Notes',
    },
    options: { status: { active: 'In use', inactive: 'Retired' } },
    mine: 'Safes you look after',
    all: 'Cash in safes',
    none: 'No safes yet',
    noneHint: 'Accounting adds the safes there are and who looks after each',
    waiting: 'To count',
    waitingCount: '{{count}} to count',
    incoming: '{{name}} put cash in',
    count: 'Count in',
    countTitle: 'Count into {{safe}}',
    countBody: '{{name}} put {{amount}} baht in. Count it all, then enter what you counted',
    counted: 'Counted',
    matches: 'Matches what was sent',
    note: 'Why it differs',
    varianceNote: 'The safe takes what you counted; the difference stays with the sender until a lead reviews it',
    confirm: 'Confirm into the safe',
    done: '{{amount}} baht counted into {{safe}}',
    deposit: 'Deposit from the safe',
    source: 'Deposit cash from',
    own: 'Cash in your hands',
  },
  move: {
    title: 'Cash move',
    plural: 'Cash moves',
    create: 'Move cash',
    fields: {
      number: 'No.',
      movedAt: 'Moved at',
      fromUserId: 'From person',
      fromSafeId: 'From safe',
      fromFund: 'From',
      toUserId: 'To person',
      toSafeId: 'To safe',
      toFund: 'Into',
      amount: 'Amount',
      reason: 'Reason',
      recordedByUserId: 'Moved by',
      notes: 'Notes',
    },
    options: { fromFund: fundEn, toFund: fundEn },
    sections: { from: 'Move from', to: 'Move to', main: 'Amount and reason' },
    person: 'Person',
    safe: 'Safe',
    hint: 'It takes effect when saved, nobody confirming. You cannot move cash into or out of your own hands',
  },
  wallet: {
    title: 'Money bag',
    total: 'Cash you should have on you',
    collections: 'Collections (to hand in)',
    collectionsHint: 'What you owe the company: 0 at the end of every day',
    collectionsOver: 'Handed in {{amount}} THB too much',
    reserve: 'Petty cash',
    reserveHint: 'Entrusted by the company for change and small expenses',
    reserveOf: '{{held}} of a {{limit}} THB float',
    reserveOver: 'Spent {{amount}} THB too much (float {{limit}} THB)',
    bond: 'Security deposit',
    bondHint: 'Your money the company holds, paid back with your final payslip',
    bondOf: '{{held}} of a {{target}} THB target',
    bondHeld: '{{held}} THB',
    bondOver: 'Taken {{amount}} THB too much',
    clearing: 'If you settled today',
    clearingHint: 'Collections and petty cash to give back, less the deposit the company pays back',
    clearingPay: 'You hand the company {{amount}} THB',
    clearingRefund: 'The company pays you {{amount}} THB',
    clearingNone: 'Nothing to hand in or pay back',
    inTransit: 'Waiting for the other side: {{amount}} THB',
    incoming: 'To confirm',
    incomingFrom: '{{name}} transferred {{amount}} THB',
    incomingReserve: '{{name}} issued {{amount}} THB of petty cash',
    incomingReserveTo: '{{name}} gave you petty cash',
    outgoing: 'Waiting for the other side',
    waiting: 'To confirm',
    received: 'Received {{amount}} THB from {{name}}',
    takenOver: 'Took over {{amount}} THB of debt from {{name}}',
    recent: 'Latest entries',
    seeAll: 'See all',
    none: 'No cash entries yet',
    expected: 'System balance',
    short: 'Short by {{amount}} THB',
    over: 'Over by {{amount}} THB',
    notEnough: 'Not enough collections ({{amount}} THB)',
    reviewNote: 'Note (required to reject)',
    reviewed: 'Review saved',
    printSlip: 'Print debt transfer',
    sendAll: 'Transfer all collections: {{amount}} THB',
  },
  overview: {
    title: 'Cash overview',
    person: 'Held by',
    collections: 'Collections to hand in',
    reserve: 'Petty cash',
    bond: 'Security deposit',
    bondTarget: 'Target',
    bondDue: 'Pay back by {{date}}',
    bondOverdue: 'Overdue since {{date}}',
    bondRefund: 'Pay back',
    bondsDue: 'Deposits to pay back',
    reserveLimit: 'Amount',
    toTopUp: 'To top up',
    inTransit: 'Waiting for the other side',
    lastHandover: 'Last cleared',
    days: '{{count}} days ago',
    today: 'Today',
    never: 'Never',
    total: 'Total',
    depositsPending: 'Deposits to verify',
    variancesPending: 'Short / over to review',
    expensesPending: 'Collections spent, to review',
  },
} satisfies typeof th
